var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.34194 3.22012C5.201 3.3611 5.12183 3.55229 5.12183 3.75163C5.12183 3.95098 5.201 4.14217 5.34194 4.28315L9.06333 8.00454L5.34194 11.7259C5.205 11.8677 5.12922 12.0576 5.13093 12.2547C5.13264 12.4519 5.21171 12.6404 5.3511 12.7798C5.49049 12.9192 5.67905 12.9983 5.87617 13C6.07328 13.0017 6.26319 12.9259 6.40498 12.789L10.6579 8.53606C10.7988 8.39508 10.878 8.20389 10.878 8.00454C10.878 7.80519 10.7988 7.614 10.6579 7.47302L6.40498 3.22012C6.264 3.07918 6.07281 3 5.87346 3C5.67411 3 5.48292 3.07918 5.34194 3.22012Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.17c1def004a7330e291c5d4cdb37fd64.svg";
export { ForwardRef as ReactComponent };